(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
    const parseRange = (s) => { const m = String(s).match(/([\d.]+)\s*-\s*([\d.]+)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; };
    const norm = (s) => String(s).trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL').replace(/^XXXXL$/, '4XL');
    const fill = (t, map) => t.replace(/\[(\w+)\]/g, (_, k) => (k in map ? map[k] : ''));

    const init = (root) => {
      if (root.dataset.sfInit) return;
      root.dataset.sfInit = '1';
      const T = JSON.parse(root.querySelector('[data-sf-text]').textContent);
      const near = parseFloat(root.dataset.near) || 0.5;
      const rows = [...root.querySelectorAll('[data-row]')];
      const sizes = rows.map((r) => ({ name: r.dataset.size, range: parseRange(r.dataset.bust), row: r })).filter((s) => s.range);
      const state = { band: null, cup: null, cupAdd: 0 };
      const el = (s) => root.querySelector(s);

      const findSize = (bust) => {
        if (!sizes.length) return null;
        if (bust < sizes[0].range[0]) return { i: 0, kind: 'below' };
        for (let i = 0; i < sizes.length; i++) {
          const [lo, hi] = sizes[i].range;
          if (bust >= lo && bust <= hi) return { i, kind: hi - bust <= near && i < sizes.length - 1 ? 'near' : 'in' };
          if (sizes[i + 1] && bust > hi && bust < sizes[i + 1].range[0]) return { i: i + 1, kind: 'gap' };
        }
        return { i: sizes.length - 1, kind: 'above' };
      };

      const show = (bust, basis) => {
        const r = findSize(bust);
        const box = el('[data-result]');
        if (!r) return;
        const size = sizes[r.i];
        const next = sizes[r.i + 1];
        box.hidden = false;
        el('[data-result-size]').textContent = size.name;
        el('[data-result-basis]').textContent = basis;
        const btn = el('[data-select]');
        btn.hidden = !pickerInputs(size.name).length;
        btn.textContent = fill(T.select, { size: size.name });
        btn.onclick = () => selectVariant(size.name);
        const note = el('[data-result-note]');
        const msg = { near: T.near_top, gap: T.gap, below: T.below, above: T.above }[r.kind];
        note.hidden = !msg;
        if (msg) note.textContent = fill(msg, { size: size.name, next: next ? next.name : '' });
        rows.forEach((row) => row.classList.toggle('is-match', row === size.row));
      };

      const fromBra = () => {
        if (!state.band || !state.cup) return;
        const bust = parseFloat(state.band) + state.cupAdd;
        show(bust, fill(T.basis_bra, { bra: state.band + state.cup }));
      };

      root.querySelectorAll('[data-group]').forEach((g) => {
        g.addEventListener('click', (e) => {
          const chip = e.target.closest('.size-finder__chip');
          if (!chip) return;
          g.querySelectorAll('.size-finder__chip').forEach((c) => c.setAttribute('aria-checked', String(c === chip)));
          if (g.dataset.group === 'band') state.band = chip.dataset.value;
          else { state.cup = chip.dataset.value; state.cupAdd = parseFloat(chip.dataset.add) || 0; }
          fromBra();
        });
      });

      const measure = () => {
        const raw = el('[data-measure]').value.toLowerCase().replace(',', '.');
        let n = parseFloat(raw);
        if (isNaN(n) || n <= 0) { el('[data-result]').hidden = false; el('[data-result-size]').textContent = '—'; el('[data-result-basis]').textContent = T.invalid; el('[data-select]').hidden = true; el('[data-result-note]').hidden = true; return; }
        const isCm = raw.includes('cm') || (!raw.includes('in') && n > 65);
        const inches = isCm ? n / 2.54 : n;
        show(inches, fill(T.basis_measure, { value: isCm ? Math.round(n) + ' cm' : n + ' in' }));
      };
      el('[data-measure-go]').addEventListener('click', measure);
      el('[data-measure]').addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); measure(); } });

      // in / cm toggle for the chart
      root.querySelectorAll('[data-unit]').forEach((b) => b.addEventListener('click', () => {
        root.querySelectorAll('[data-unit]').forEach((x) => x.classList.toggle('is-active', x === b));
        root.querySelectorAll('td[data-in]').forEach((td) => {
          td.textContent = b.dataset.unit === 'in' ? td.dataset.in : td.dataset.in.replace(/[\d.]+/g, (v) => Math.round(parseFloat(v) * 2.54));
        });
      }));

      // variant picker in the same section
      const scope = () => root.closest('.shopify-section') || document;
      const pickerInputs = (name) => [...scope().querySelectorAll('variant-picker input[type="radio"], variant-picker select option')].filter((i) => norm(i.value) === norm(name));
      const selectVariant = (name) => {
        const match = pickerInputs(name)[0];
        if (!match) return;
        if (match.tagName === 'OPTION') {
          const sel = match.closest('select');
          sel.value = match.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          match.click();
        }
        match.closest('fieldset, .variant-option')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
    };

    const boot = () => document.querySelectorAll('[data-size-finder]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sm-ft-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
    const LBS_PER_KG = 2.20462;
    const parseRange = (s) => { const m = String(s).match(/([\d.]+)\s*-\s*([\d.]+)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; };
    const norm = (s) => String(s).trim().toUpperCase().replace(/\s+/g, '');
    const fill = (t, map) => t.replace(/\[(\w+)\]/g, (_, k) => (k in map ? map[k] : ''));
    // 5'1" → 155 cm (heights in the chart are typed in feet and inches)
    const toCm = (s) => s.replace(/(\d+)\s*'\s*(\d+)?\s*"?/g, (_, ft, inch) => Math.round((parseInt(ft, 10) * 12 + (parseInt(inch, 10) || 0)) * 2.54));

    const init = (root) => {
      if (root.dataset.smSfInit) return;
      root.dataset.smSfInit = '1';
      const T = JSON.parse(root.querySelector('[data-sf-text]').textContent);
      const near = parseFloat(root.dataset.near) || 0;
      const rows = [...root.querySelectorAll('[data-row]')];
      const sizes = rows.map((r) => ({ name: r.dataset.size, range: parseRange(r.dataset.weight), row: r })).filter((s) => s.range);
      const el = (s) => root.querySelector(s);
      const input = el('[data-ft-weight]');
      let unit = 'us';

      // weights between two ranges go to the next size up
      const findSize = (lbs) => {
        if (!sizes.length) return null;
        if (lbs < sizes[0].range[0]) return { i: 0, kind: 'below' };
        for (let i = 0; i < sizes.length; i++) {
          const [lo, hi] = sizes[i].range;
          if (lbs >= lo && lbs <= hi) return { i, kind: hi - lbs < near && i < sizes.length - 1 ? 'near' : 'in' };
          if (sizes[i + 1] && lbs > hi && lbs < sizes[i + 1].range[0]) return { i: i + 1, kind: 'in' };
        }
        return { i: sizes.length - 1, kind: 'above' };
      };

      const find = () => {
        const n = parseFloat(input.value.replace(',', '.'));
        const box = el('[data-result]');
        const btn = el('[data-select]');
        const note = el('[data-result-note]');
        box.hidden = false;
        if (isNaN(n) || n <= 0) {
          el('[data-result-size]').textContent = '—';
          el('[data-result-basis]').textContent = T.invalid;
          btn.hidden = true;
          note.hidden = true;
          rows.forEach((row) => row.classList.remove('is-match'));
          return;
        }
        const lbs = unit === 'metric' ? n * LBS_PER_KG : n;
        const r = findSize(lbs);
        if (!r) return;
        const size = sizes[r.i];
        const next = sizes[r.i + 1];
        el('[data-result-size]').textContent = size.name;
        el('[data-result-basis]').textContent = fill(T.basis, { weight: n + (unit === 'metric' ? ' kg' : ' lbs') });
        btn.hidden = !pickerInputs(size.name).length;
        btn.textContent = fill(T.select, { size: size.name });
        btn.onclick = () => selectVariant(size.name);
        const msg = { near: T.near_top, below: T.below, above: T.above }[r.kind];
        note.hidden = !msg;
        if (msg) note.textContent = fill(msg, { size: size.name, next: next ? next.name : '' });
        rows.forEach((row) => row.classList.toggle('is-match', row === size.row));
      };
      el('[data-ft-go]').addEventListener('click', find);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); find(); } });

      // US (lbs, feet/inches) / Metric (kg, cm): switches the input and the chart; a typed weight is converted
      root.querySelectorAll('[data-ft-unit]').forEach((b) => b.addEventListener('click', () => {
        const nextUnit = b.dataset.ftUnit;
        if (nextUnit === unit) return;
        const n = parseFloat(input.value.replace(',', '.'));
        if (!isNaN(n) && n > 0) input.value = Math.round(nextUnit === 'metric' ? n / LBS_PER_KG : n * LBS_PER_KG);
        unit = nextUnit;
        root.querySelectorAll('[data-ft-unit]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
        input.placeholder = input.dataset[unit === 'metric' ? 'placeholderMetric' : 'placeholderUs'];
        root.querySelectorAll('td[data-lbs]').forEach((td) => {
          td.textContent = unit === 'us' ? td.dataset.lbs + ' lbs' : td.dataset.lbs.replace(/[\d.]+/g, (v) => Math.round(parseFloat(v) / LBS_PER_KG)) + ' kg';
        });
        root.querySelectorAll('td[data-ftin]').forEach((td) => {
          td.textContent = unit === 'us' ? td.dataset.ftin : (td.dataset.ftin ? toCm(td.dataset.ftin) + ' cm' : '');
        });
        if (!el('[data-result]').hidden && input.value) find();
      }));

      // variant picker in the same section
      const scope = () => root.closest('.shopify-section') || document;
      const pickerInputs = (name) => [...scope().querySelectorAll('variant-picker input[type="radio"], variant-picker select option')].filter((i) => norm(i.value) === norm(name));
      const selectVariant = (name) => {
        const match = pickerInputs(name)[0];
        if (!match) return;
        if (match.tagName === 'OPTION') {
          const sel = match.closest('select');
          sel.value = match.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          match.click();
        }
        match.closest('fieldset, .variant-option')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
    };

    const boot = () => document.querySelectorAll('[data-sm-ft-size-finder]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sm-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
    const parseRange = (s) => { const m = String(s).match(/([\d.]+)\s*-\s*([\d.]+)/); return m ? [parseFloat(m[1]), parseFloat(m[2])] : null; };
    const norm = (s) => String(s).trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL').replace(/^XXXXL$/, '4XL');
    const fill = (t, map) => t.replace(/\[(\w+)\]/g, (_, k) => (k in map ? map[k] : ''));

    const init = (root) => {
      if (root.dataset.smSfInit) return;
      root.dataset.smSfInit = '1';
      const T = JSON.parse(root.querySelector('[data-sf-text]').textContent);
      const near = parseFloat(root.dataset.near) || 0.5;
      const rows = [...root.querySelectorAll('[data-row]')];
      const sizes = rows.map((r) => ({ name: r.dataset.size, range: parseRange(r.dataset.bust), row: r })).filter((s) => s.range);
      const S = { us: { band: null, cup: null, in: 0, add: 0 }, eu: { band: null, cup: null, in: 0, add: 0 } };
      let sys = 'us';
      const other = (s) => (s === 'us' ? 'eu' : 'us');
      const chipsOf = (s, group) => [...root.querySelectorAll(`[data-system="${s}"] [data-group="${group}"] .sm-size-finder__chip`)];
      const el = (s) => root.querySelector(s);

      const findSize = (bust) => {
        if (!sizes.length) return null;
        if (bust < sizes[0].range[0]) return { i: 0, kind: 'below' };
        for (let i = 0; i < sizes.length; i++) {
          const [lo, hi] = sizes[i].range;
          if (bust >= lo && bust <= hi) return { i, kind: hi - bust <= near && i < sizes.length - 1 ? 'near' : 'in' };
          if (sizes[i + 1] && bust > hi && bust < sizes[i + 1].range[0]) return { i: i + 1, kind: 'gap' };
        }
        return { i: sizes.length - 1, kind: 'above' };
      };

      const show = (bust, basis) => {
        const r = findSize(bust);
        const box = el('[data-result]');
        if (!r) return;
        const size = sizes[r.i];
        const next = sizes[r.i + 1];
        box.hidden = false;
        el('[data-result-size]').textContent = size.name;
        el('[data-result-basis]').textContent = basis;
        el('[data-result-equiv]').hidden = true;
        const btn = el('[data-select]');
        btn.hidden = !pickerInputs(size.name).length;
        btn.textContent = fill(T.select, { size: size.name });
        btn.onclick = () => selectVariant(size.name);
        const note = el('[data-result-note]');
        const msg = { near: T.near_top, gap: T.gap, below: T.below, above: T.above }[r.kind];
        note.hidden = !msg;
        if (msg) note.textContent = fill(msg, { size: size.name, next: next ? next.name : '' });
        rows.forEach((row) => row.classList.toggle('is-match', row === size.row));
      };

      const pick = (s, chip) => {
        const g = chip.closest('[data-group]');
        g.querySelectorAll('.sm-size-finder__chip').forEach((c) => c.setAttribute('aria-checked', String(c === chip)));
        if (g.dataset.group === 'band') { S[s].band = chip.dataset.value; S[s].in = parseFloat(chip.dataset.in) || 0; }
        else { S[s].cup = chip.dataset.value; S[s].add = parseFloat(chip.dataset.add) || 0; }
      };

      // same bra size in the other system: band with the same inches, first cup with the same step
      const equivalent = (s) => {
        const o = other(s);
        const band = chipsOf(o, 'band').find((c) => parseFloat(c.dataset.in) === S[s].in);
        const cup = chipsOf(o, 'cup').find((c) => parseFloat(c.dataset.add) === S[s].add);
        return band && cup ? { band, cup } : null;
      };

      const fromBra = () => {
        const st = S[sys];
        if (!st.band || !st.cup) return;
        show(st.in + st.add, fill(T.basis_bra, { bra: st.band + st.cup }));
        const eq = root.querySelector('[data-system-btn]') ? equivalent(sys) : null;
        const line = el('[data-result-equiv]');
        line.hidden = !eq;
        if (eq) line.textContent = fill(T.equiv, { system: T['label_' + other(sys)], size: eq.band.dataset.value + eq.cup.dataset.value });
      };

      root.querySelectorAll('[data-group]').forEach((g) => {
        g.addEventListener('click', (e) => {
          const chip = e.target.closest('.sm-size-finder__chip');
          if (!chip) return;
          pick(g.closest('[data-system]').dataset.system, chip);
          fromBra();
        });
      });

      // US / EU switch: carries the chosen size over to the other system
      root.querySelectorAll('[data-system-btn]').forEach((b) => b.addEventListener('click', () => {
        const next = b.dataset.systemBtn;
        if (next === sys) return;
        const st = S[sys];
        if (st.band && st.cup) {
          const eq = equivalent(sys);
          if (eq) { pick(next, eq.band); pick(next, eq.cup); }
        }
        sys = next;
        root.querySelectorAll('[data-system-btn]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
        root.querySelectorAll('[data-system]').forEach((box) => { box.hidden = box.dataset.system !== sys; });
        fromBra();
      }));

      const measure = () => {
        const raw = el('[data-measure]').value.toLowerCase().replace(',', '.');
        let n = parseFloat(raw);
        if (isNaN(n) || n <= 0) { el('[data-result]').hidden = false; el('[data-result-size]').textContent = '—'; el('[data-result-basis]').textContent = T.invalid; el('[data-select]').hidden = true; el('[data-result-note]').hidden = true; el('[data-result-equiv]').hidden = true; return; }
        const isCm = raw.includes('cm') || (!raw.includes('in') && n > 65);
        const inches = isCm ? n / 2.54 : n;
        show(inches, fill(T.basis_measure, { value: isCm ? Math.round(n) + ' cm' : n + ' in' }));
      };
      el('[data-measure-go]').addEventListener('click', measure);
      el('[data-measure]').addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); measure(); } });

      // in / cm toggle for the chart
      root.querySelectorAll('[data-unit]').forEach((b) => b.addEventListener('click', () => {
        root.querySelectorAll('[data-unit]').forEach((x) => x.classList.toggle('is-active', x === b));
        root.querySelectorAll('td[data-in]').forEach((td) => {
          td.textContent = b.dataset.unit === 'in' ? td.dataset.in : td.dataset.in.replace(/[\d.]+/g, (v) => Math.round(parseFloat(v) * 2.54));
        });
      }));

      // variant picker in the same section
      const scope = () => root.closest('.shopify-section') || document;
      const pickerInputs = (name) => [...scope().querySelectorAll('variant-picker input[type="radio"], variant-picker select option')].filter((i) => norm(i.value) === norm(name));
      const selectVariant = (name) => {
        const match = pickerInputs(name)[0];
        if (!match) return;
        if (match.tagName === 'OPTION') {
          const sel = match.closest('select');
          sel.value = match.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          match.click();
        }
        match.closest('fieldset, .variant-option')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
    };

    const boot = () => document.querySelectorAll('[data-sm-size-finder]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-peek-carousel"] && !Shopify.designMode) return;
  try {
    function initVideoPeekCarousel(root) {
    const track = root.querySelector('[data-vpc-track]');
    const dotsWrapper = root.closest('.video-peek-carousel-wrapper')?.querySelector('[data-vpc-dots]');
    const dots = dotsWrapper ? Array.from(dotsWrapper.querySelectorAll('[data-vpc-dot]')) : [];
    const items = Array.from(root.querySelectorAll('[data-vpc-item]'));
    const prevArrow = root.querySelector('[data-vpc-arrow="prev"]');
    const nextArrow = root.querySelector('[data-vpc-arrow="next"]');

    if (!track || items.length === 0) return;

    const updateActiveDot = () => {
      if (!dots.length) return;
      const trackRect = track.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));

      if (prevArrow) prevArrow.disabled = track.scrollLeft <= 4;
      if (nextArrow) nextArrow.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };

    track.addEventListener('scroll', updateActiveDot, { passive: true });
    updateActiveDot();

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const item = items[index];
        if (item) {
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    const scrollByOneItem = (direction) => {
      const itemWidth = items[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
    };

    if (prevArrow) prevArrow.addEventListener('click', () => scrollByOneItem(-1));
    if (nextArrow) nextArrow.addEventListener('click', () => scrollByOneItem(1));
  }

  document.querySelectorAll('[data-video-peek-carousel]').forEach(initVideoPeekCarousel);
  } catch(e) { console.error(e); }
})();

})();
